import styled, { css } from 'styled-components';

import { hexToRGB } from '@/styles/helpers';

export interface ScCountdownWidgetProps {
  accent?: boolean;
  showCountdown?: boolean;
  withBg?: boolean;
}

export const ScCountdownWidgetCard = styled.div<ScCountdownWidgetProps>`
  position: absolute;
  z-index: 3;
  top: 16px;
  right: 12px;
  inset: 16px 12px auto auto;
  border-radius: 8px;
  display: flex;
  column-gap: 4px;
  flex-wrap: nowrap;
  align-items: center;
  height: 24px;
  padding-inline: 4px;

  ${({ withBg }) =>
    withBg &&
    css`
      background-color: ${({ theme }) => hexToRGB(theme.blackColor, 0.2)};
      padding: 8px 12px;
      height: auto;
      position: relative;
      inset: unset;
    `}

  @container tournament-card (width > 626px) {
    inset: auto auto 16px 16px;
    padding: 8px;
    column-gap: 8px;
    height: 48px;
    padding-inline: 16px;
    background-color: ${({ theme }) => hexToRGB(theme.blackColor, 0.4)};
  }

  .label {
    position: relative;
    font-weight: 700;
    font-size: 10px;
    line-height: 100%;
    letter-spacing: 0.2px;
    text-transform: capitalize;
    white-space: pre-line;
    text-align: left;
    color: ${({ theme, accent }) =>
      accent ? theme.secondaryColorHover : theme.whiteColor};

    @container tournament-card (width > 626px) {
      font-size: 16px;
      letter-spacing: 0.48px;
    }

    ${({ showCountdown }) =>
      showCountdown &&
      css`
        &.fr-CH,
        &.fr-CA {
          @media (max-width: 380px) {
            display: none;
          }
        }
        &.de {
          @media (max-width: 360px) {
            display: none;
          }
        }
      `}
  }
  .countdown {
    color: ${({ theme, accent }) =>
      accent ? theme.secondaryColorHover : theme.whiteColor};
    font-size: 14px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: 0.42px;
    font-variant-numeric: tabular-nums;
    display: flex;
    column-gap: 2px;

    @container tournament-card (width > 626px) {
      font-size: 20px;
      letter-spacing: 0.6px;
    }

    span {
      position: relative;
      display: inline-block;
      padding-bottom: 10px;
      text-align: center;

      &::before {
        position: absolute;
        display: block;
        content: attr(attr-label);
        font-size: 10px;
        line-height: 100%;
        white-space: nowrap;
        left: 50%;
        transform: translateX(-50%);
        text-transform: lowercase;
        bottom: 0;
        font-weight: 400;
        color: ${({ theme, accent }) =>
          accent
            ? hexToRGB(theme.secondaryColorHover, 0.6)
            : hexToRGB(theme.whiteColor, 0.6)};
      }
    }
  }
`;

export const ScCountdownWidget = styled.div`
  .timer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    line-height: 16px;

    span {
      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0.36px;
    }

    .value {
      min-width: 24px;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0.48px;
    }

    .text {
      font-size: 12px;
      line-height: 12px;
    }
  }
`;
